import styled from "styled-components";


export const InnerContainer = styled.div`
  width: 150px;
  height: 41px;
  display: flex;
  justify-content: center;
  margin-top: 30px;
`

export const IconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-bottom: 30px;
`
